import React from 'react';
import PropTypes from 'prop-types';
import { createUniversalPortal } from 'react-portal-universal';
import ImageZoom from '../ImageZoom';
import Title from '../Title';
import HeaderWrapper from '../HeaderWrapper';
import CodeBlock from '../CodeBlock';
import MicrositeSteps from '../Microsites/Steps';
import MicrositeFurtherReading from '../Microsites/FurtherReading';
import DefinitionTooltip from '../DefinitionTooltip';
import VideoWrapper from '../VideoWrapper';

const portalComponents = {
  Title,
  HeaderWrapper,
  ImageZoom,
  CodeBlock,
  MicrositeSteps,
  MicrositeFurtherReading,
  DefinitionTooltip,
  VideoWrapper
};

const PortalsRenderer = ({ portals, meta, canUseDom }) => (
  portals.map(({ component, containerID, props }) => {
    if (canUseDom) {
      const container = document.getElementById(`${containerID}`);
      if (!container) return null;
    }

    const Component = portalComponents[component];
    return createUniversalPortal(
      <Component {...props} meta={meta} />,
      `#${containerID}`
    );
  })
);


PortalsRenderer.propTypes = {
  portals: PropTypes.array.isRequired,
  meta: PropTypes.object.isRequired
};

export default PortalsRenderer;
